<template>
    <div>
        <div class="row row-eq-height my-2">
            <div class="col-sm-6 mb-3 mb-sm-0">
                <div class="border border-grey rounded p-3 h-100">
                    <div class="row">
                        <div class="col-9">
                            <p class="fs-18 mb-2">{{ $t('notFound.box1.title') }}</p>
                            <p class="mb-2">{{ $t('notFound.box1.desc') }}</p>
                            <a
                                href="/form-recommend"
                                class="btn btn-outline-primary btn-xs px-3 mt-2"
                                :title="$t('notFound.box1.title')"
                                rel="nofollow"
                            >
                                {{ $t('notFound.box1.btnText') }}
                            </a>
                        </div>
                        <div class="col-3 text-right">
                            <img
                                v-lazy-load
                                src="/nuxt-assets/images/lazy-load-error.svg"
                                data-src="/nuxt-assets/images/png/package-1.png"
                                width="47"
                                height="54"
                                :alt="$t('notFound.box1.title')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="border border-grey rounded p-3 h-100">
                    <div class="row">
                        <div class="col-9">
                            <p class="fs-18 mb-2">{{ $t('notFound.box2.title') }}</p>
                            <p class="mb-2">
                                {{ $t('notFound.box2.desc') }}
                            </p>
                            <button
                                title="Potřebujete poradit?"
                                class="btn btn-outline-primary btn-xs px-3 mt-2"
                                rel="nofollow"
                                @click="$bus.$emit('showModal', 'modal-askus')"
                            >
                                {{ $t('notFound.box2.btnText') }}
                            </button>

                            <Modal id="modal-askus" modal-name="modal-askus" :title="$t('askUs.title')" @shown="initContactForm">
                                <div id="js-ask-us-form-message" class="alert alert-success d-none px-5" role="alert" fade>
                                    {{ $t('formRecommend.send') }}
                                </div>
                                <form id="js-ask-us-form" novalidate>
                                    <div class="container-fluid clearfix">
                                        <div class="form-group">
                                            <div class="position-relative mb-2">
                                                <label for="send-tip" class="mb-1">E-mail: <span class="text-danger fs-16">*</span></label>
                                                <input
                                                    id="js-ask-us-email"
                                                    v-model="email"
                                                    class="form-control mb-3"
                                                    data-validate-field="email"
                                                    data-at="form-ask-email"
                                                    type="text"
                                                    name="email"
                                                    :placeholder="$t('askUs.yourEmail')"
                                                />

                                                <input type="hidden" name="name" value="undefined_product_or_category" />
                                            </div>

                                            <div class="position-relative">
                                                <label for="message" class="mb-1">
                                                    {{ $t('askUs.yourQuestion') }}: <span class="text-danger fs-16">*</span>
                                                </label>
                                                <textarea
                                                    id="message"
                                                    v-model="message"
                                                    class="form-control"
                                                    name="message"
                                                    data-at="form-ask-message"
                                                    rows="3"
                                                    :placeholder="$t('askUs.yourQuestion')"
                                                    data-validate-field="message"
                                                ></textarea>
                                            </div>

                                            <div class="position-relative mt-3">
                                                <div class="form-check">
                                                    <input
                                                        id="conditions"
                                                        v-model="isAgreeWithTermsChecked"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        value=""
                                                        name="conditions"
                                                        :class="{ 'is-active': isAgreeWithTermsChecked }"
                                                        required
                                                    />
                                                    <label class="form-check-label" for="conditions">
                                                        <b>
                                                            {{ $t('formRecommend.agree.text') }}
                                                            <a :href="$t('formRecommend.agree.url')" target="_blank" class="text-primary">
                                                                {{ $t('formRecommend.agree.link') }}
                                                            </a>
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="row align-items-center">
                                                <div class="col-12 col-md-8">
                                                    <p class="d-block mt-3">
                                                        {{ $t('askUs.itemsWithAsterisk') }} (<span class="text-danger fs-16">*</span>)
                                                        {{ $t('askUs.areRequired') }}.
                                                    </p>
                                                </div>

                                                <div class="col-12 col-md-4">
                                                    <button type="submit" class="btn btn-primary float-right" data-at="form-ask-submit">
                                                        {{ $t('askUs.sendQuestion') }}
                                                        <span class="arrow arrow--right"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </Modal>
                        </div>
                        <div class="col-3 text-right">
                            <img
                                v-lazy-load
                                src="/nuxt-assets/images/lazy-load-error.svg"
                                data-src="/nuxt-assets/images/png/girl.png"
                                width="59"
                                height="57"
                                :alt="$t('notFound.box2.title')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Modal from '../Modal.vue'

export default {
    components: {
        Modal,
    },
    data() {
        return {
            message: '',
            email: '',
            isAgreeWithTermsChecked: false,
        }
    },
    mounted() {
        this.initContactForm()
    },
    methods: {
        initContactForm() {
            if (!window) {
                return
            }

            const form = document.getElementById('js-ask-us-form')
            if (!form) {
                return
            }

            form.addEventListener('submit', (e) => {
                e.preventDefault()

                this.submitContactForm(form)
            })
        },

        async submitContactForm(form: HTMLFormElement) {
            const url = '/api/v2/contact/send-message?legacy'
            const inputData = new FormData(form)
            const response = await $fetch(url, {
                method: 'POST',
                body: inputData,
            })
            // @ts-ignore
            if (response.result === true) {
                document.getElementById('js-ask-us-form-message')?.classList.remove('d-none')
                document.getElementById('js-ask-us-form')?.classList.add('d-none')
            } else {
                alert('Form is not submitted, please contact vyvojari@pilulka.cz')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.alert {
    background: $color-white;
    position: relative;
    box-shadow: inset 0 0 0 1px rgba($color-white, 0.2);
    padding-left: 50px;

    &-success {
        padding: 15px;
        border: 0;
        background: $color-green-dark;
        color: $color-white;
    }
}
</style>
